export var VERSION = '2.9.3';
//# sourceMappingURL=version.js.map